import { gql } from '@apollo/client';

export const ADD_MY_CB_TALENT_ADMIN = gql`
  mutation AddMyCbTalentAdmin($input: AddMyCbTalentAdminInput!) {
    addMyCbTalentAdmin(input: $input) {
      id
      source
      status
      agencyId
      userId
      firstWorkedAt
      lastWorkedAt
      lastRate
    }
  }
`;
